export default function (content) {
  return `${content}`.match(/data:image\/([a-zA-Z]*);base64,([^\"]*)/, "g");
}
